import FeedbackIcon from '@atlaskit/icon/core/feedback';
import { Box, xcss } from '@atlaskit/primitives';
import { MenuButtonItem } from '@atlassian/navigation-system/v4';
import React from 'react';
import { useIntl } from 'react-intl-next';

import { useModalActions } from '@townsquare/modals';

const style = xcss({
  insetBlockEnd: 'space.0',
  position: 'absolute',
  width: '100%',
  borderBlockStartColor: 'color.border',
  borderBlockStartStyle: 'solid',
  borderBlockStartWidth: 'border.width',
});

export const GiveFeedbackButton = () => {
  const intl = useIntl();
  const { openModal } = useModalActions();

  return (
    <Box padding="space.150" backgroundColor="elevation.surface" xcss={style}>
      <MenuButtonItem
        elemBefore={<FeedbackIcon label="" />}
        onClick={() =>
          openModal('feedback-modal', {
            redirectOnSave: false,
            feedbackEntryPoint: 'Atlas - New Navigation',
          })
        }
      >
        {intl.formatMessage({
          id: 'townsquare.atlassian-home.side-nav.give-feedback',
          description: 'Label to give feedback about new nav EAP',
          defaultMessage: 'Give feedback on the new navigation',
        })}
      </MenuButtonItem>
    </Box>
  );
};
